import { LogoName } from "../../constant";
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

export const footerInfo = {
  title: LogoName,
  description:
    "Our system is used in jewelry stores, department stores, salons, pharmacies, doctors’ offices, and body piercing shops in over 70 countries worldwide.",
  gmail: { icon: <MailOutlined />, mail: "info@invernessindia.com" },
  phone: { icon: <PhoneOutlined />, number: "(+91)2245021234" },
  icons: [
    // { tooltip: "follow on Facebook", icon: <FacebookOutlined /> },
    // { tooltip: "follow on Twitter", icon: <TwitterOutlined /> },
    {
      tooltip: "follow on Instagram",
      icon: <InstagramOutlined />,
    },
  ],
};

export const footerOther = [
  {
    title: "Categories",
    items: [
      {
        name: "Gold",
        subItems: ["14Kt Gold", "18Kt Gold"],
      },
      {
        name: "Non Gold",
        subItems: ["GP", "MISC", "SS", "STS", "TI"],
      },
    ],
  },

  {
    title: "Quick Links",
    items: [
      "About Us",
      "Privacy-Policy",
      "Terms-of-Use",
      // "Terms of service",
      // "Refund policy",
    ],
  },
];
